import type { Testimonial } from '@/types/content';

// TODO: Replace these placeholder testimonials with real customer quotes and photos when available
// Current content uses fictional companies and stock photos
export const testimonials: Testimonial[] = [
  {
    id: '1',
    quote:
      "We went from 5 techs to 25 in two years. Omniforge scaled with us every step of the way. The implementation team made sure we were set up for success from day one.",
    author: 'Mike Richardson',
    role: 'Owner',
    company: 'Richardson HVAC',
    industry: 'hvac',
    imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Team Growth',
      value: '5x',
    },
  },
  {
    id: '2',
    quote:
      "I used to spend every Sunday doing payroll and scheduling. Now it takes me 30 minutes. Omniforge gave me my weekends back.",
    author: 'Sarah Chen',
    role: 'Operations Manager',
    company: 'Elite Plumbing Solutions',
    industry: 'plumbing',
    imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Admin Time Saved',
      value: '75%',
    },
  },
  {
    id: '3',
    quote:
      "The Business Rhythm tools are a game-changer. Our weekly meetings actually work now because everything we need is in one place. Goals, scorecards, issues—all connected to our daily operations.",
    author: 'David Martinez',
    role: 'CEO',
    company: 'Spark Electric',
    industry: 'electrical',
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Meeting Efficiency',
      value: '2x',
    },
  },
  {
    id: '4',
    quote:
      "We switched from ServiceTitan and saved over $800/month. Plus, the support team actually picks up the phone. It's refreshing.",
    author: 'Jennifer Williams',
    role: 'Owner',
    company: 'Williams Landscaping',
    industry: 'landscaping',
    imageUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Monthly Savings',
      value: '$800+',
    },
  },
  {
    id: '5',
    quote:
      "Route optimization alone pays for the software. My crews are finishing earlier and hitting more stops. Fuel costs are down 15%.",
    author: 'Tom Baker',
    role: 'Operations Director',
    company: 'Crystal Clear Window Cleaning',
    industry: 'window-cleaning',
    imageUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Fuel Savings',
      value: '15%',
    },
  },
  {
    id: '6',
    quote:
      "The mobile app is bulletproof. Works even when my guys are in basements with no signal. Syncs everything when they're back online.",
    author: 'Carlos Ramirez',
    role: 'Field Supervisor',
    company: 'Precision Pressure Washing',
    industry: 'pressure-washing',
    imageUrl: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Offline Capable',
      value: '100%',
    },
  },
  {
    id: '7',
    quote:
      "Storm season used to be chaos. Now we handle 3x the volume with the same crew. The job board and crew scheduling are incredible.",
    author: 'Brandon Mitchell',
    role: 'Owner',
    company: 'Apex Roofing Co.',
    industry: 'roofing',
    imageUrl: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Volume Increase',
      value: '3x',
    },
  },
  {
    id: '8',
    quote:
      "Managing 40 cleaning crews across the city was impossible before Omniforge. Now I see everyone in real-time and our customer complaints dropped 60%.",
    author: 'Patricia Nguyen',
    role: 'Operations Manager',
    company: 'Sparkle Clean Services',
    industry: 'carpet-cleaning',
    imageUrl: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Complaints Reduced',
      value: '60%',
    },
  },
  {
    id: '9',
    quote:
      "Pool season is short and intense. Omniforge helps us maximize every route and never miss a weekly service. Chemical tracking alone is worth it.",
    author: 'Derek Simmons',
    role: 'Owner',
    company: 'Blue Wave Pool & Spa',
    industry: 'pool-service',
    imageUrl: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'Stops Per Day',
      value: '+35%',
    },
  },
  {
    id: '10',
    quote:
      "Parts inventory was killing us. We'd show up without the right compressor or board and waste the whole trip. Now the system tells us exactly what to bring.",
    author: 'James Patterson',
    role: 'Service Manager',
    company: 'Fix-It Appliance Pros',
    industry: 'appliance-repair',
    imageUrl: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=120&h=120&fit=crop&crop=face',
    stats: {
      label: 'First-Visit Fix Rate',
      value: '92%',
    },
  },
];

export function getTestimonialsByIndustry(industry: string): Testimonial[] {
  return testimonials.filter((t) => t.industry === industry);
}

export function getFeaturedTestimonials(count = 3): Testimonial[] {
  return testimonials.slice(0, count);
}
